// import React from 'react'

// import ContactUsCTR from '../containers/contact-us/ContactUsCTR'

// function ContactUs() {
//     return (
//         <>
//             <ContactUsCTR />
//         </>
//     )
// }

// export default ContactUs

import React from 'react'
import { Helmet } from 'react-helmet-async';

import ContactUsCTR from '../containers/contact-us/ContactUsCTR'

function ContactUs() {
    return (
        <>
            <Helmet>
                <title>
                    Contact Bonvoy Tourism | +971-55-9215470 | Book Dubai Tours
                </title>
                <meta
                    name="description"
                    content="Book a Dubai tour or get a custom quote. Call us on +971-55-9215470 or email contact@bonvoytourism.com. We're available 24/7 to help plan your adventure."
                />
                <link rel="canonical" href="https://bonvoytourism.com/contactus" />
            </Helmet>

            <ContactUsCTR />
        </>
    )
}

export default ContactUs